"use client";
import type { ReactElement } from "react";
import { FatalErrorPanel } from "@/components/FatalErrorPanel";

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

/**
 * The last resort: a throw in the root layout itself, which error.tsx sits
 * inside of and therefore cannot catch. It replaces the whole document, so it
 * has to bring its own <html> and <body> — and its panel has to stand up
 * without the stylesheet the failed layout was responsible for importing.
 */
export default function GlobalError({ reset }: Props): ReactElement {
  return (
    <html lang="en">
      <body style={{ margin: 0 }}>
        <FatalErrorPanel onRetry={reset} />
      </body>
    </html>
  );
}
